<div class="relative">
  <button
    [matMenuTriggerFor]="listMenu"
    #listMenuTrigger="matMenuTrigger"
    [class.border-red-500]="showError"
    [class.border-slate-300]="!showError"
    class="flex items-center gap-2 px-3 py-1.5 bg-white border rounded-xl hover:bg-slate-50 transition-all cursor-pointer group"
    (click)="$event.stopPropagation()"
  >
    <span class="text-sm font-medium text-slate-700">
      {{ store.activeList()?.name }}
    </span>
    <lucide-angular
      [img]="ChevronDownIcon"
      class="w-4 h-4 text-slate-400 group-hover:text-slate-600 transition-colors"
    ></lucide-angular>
  </button>

  @if (showError) {
    <span
      class="absolute -bottom-5 left-0 text-[10px] font-medium text-red-500"
    >
      A list must be selected.
    </span>
  }

  <mat-menu
    #listMenu="matMenu"
    class="!rounded-2xl !shadow-xl !border !border-slate-200 !mt-2 !min-w-[280px] overflow-hidden"
  >
    <div
      class="px-4 py-3 border-b border-slate-100 bg-slate-50/50 flex items-center justify-between"
    >
      <h3 class="text-xs font-bold text-slate-500 uppercase tracking-wider m-0">
        Lists
      </h3>
      <lucide-angular
        [img]="ListIcon"
        class="w-4 h-4 text-slate-400"
      ></lucide-angular>
    </div>

    <div
      tabindex=""
      role="button"
      class="p-2"
      (click)="$event.stopPropagation()"
    >
      <div class="relative flex items-center">
        <lucide-angular
          [img]="SearchIcon"
          class="absolute left-2 w-3.5 h-3.5 text-slate-400 top-1/2 -translate-y-1/2"
        ></lucide-angular>

        <input
          type="text"
          placeholder="Search lists..."
          [ngModel]="store.searchTerm()"
          class="w-full pl-8 pr-3 py-2 bg-slate-100 border border-slate-300 rounded-lg text-sm text-slate-800 outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all placeholder:text-slate-400"
        />
      </div>
    </div>

    <div
      class="px-4 py-2 text-[10px] font-bold text-slate-400 uppercase tracking-widest bg-white"
    >
      Unparented
    </div>

    <div class="max-h-[200px] overflow-y-auto py-1">
      @for (list of store.filteredLists(); track list.id) {
        <div
          tabindex=""
          role="button"
          (click)="selectList(list.id)"
          class="px-4 py-2.5 flex items-center justify-between hover:bg-slate-50 cursor-pointer group transition-colors"
          [class.bg-blue-50]="selectedList?.id === list.id"
        >
          <div class="flex items-center gap-3">
            @if (list.name) {
              <lucide-angular
                [img]="ZapIcon"
                class="w-3.5 h-3.5 text-amber-500"
              ></lucide-angular>
            }
            <span
              class="text-sm font-medium"
              [class.text-blue-700]="selectedList?.id === list.id"
              [class.text-slate-700]="selectedList?.id !== list.id"
            >
              {{ list.name }}
            </span>
          </div>

          <div
            class="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity"
          >
            <!-- <button
              (click)="handleNewList(listType.NORMAL_LIST,list.id); $event.stopPropagation()"
              class="p-1 hover:bg-white rounded text-slate-400 hover:text-blue-600 border border-transparent hover:border-slate-200"
            >
              <lucide-angular
                [img]="ZapIcon"
                class="w-3.5 h-3.5"
              ></lucide-angular>
            </button> -->
            <button
              (click)="handleNewList(listType.CONSTRUCTED_LIST,list.id); $event.stopPropagation()"
              class="p-1 hover:bg-white rounded text-slate-400 hover:text-slate-600 border border-transparent hover:border-slate-200"
            >
              <lucide-angular
                [img]="EditIcon"
                class="w-3.5 h-3.5"
              ></lucide-angular>
            </button>
          </div>
        </div>
      } @empty {
        <div class="px-4 py-8 text-center text-slate-400 text-xs italic">
          No lists found
        </div>
      }
    </div>

    <div class="border-t border-slate-100 bg-slate-50/30">
      <button
        mat-menu-item
        (click)="handleNewList(listType.NORMAL_LIST,undefined)"
        class="!h-12 !px-4 hover:!bg-slate-100/80 transition-colors"
      >
        <div class="flex items-center gap-3 w-full">
          <lucide-angular
            [img]="PlusIcon"
            class="w-4 h-4 text-blue-600 flex-shrink-0"
          ></lucide-angular>
          <span class="text-sm font-semibold text-blue-600 whitespace-nowrap">
            New list
          </span>
        </div>
      </button>

      <div class="h-[1px] bg-slate-100 mx-2"></div>

      <!-- <button
        mat-menu-item
        (click)="handleCarryForward()"
        class="!h-12 !px-4 hover:!bg-slate-100/80 transition-colors"
      >
        <div class="flex items-center gap-3 w-full">
          <lucide-angular
            [img]="RefreshIcon"
            class="w-4 h-4 text-slate-500 flex-shrink-0"
          ></lucide-angular>
          <span class="text-sm font-medium text-slate-600 whitespace-nowrap">
            Carry forward items
          </span>
        </div>
      </button> -->
    </div>
  </mat-menu>
</div>
